// ============================================================
// 260901 鵠屋EC 共通JS
// 1. FeaturedCollection／ブログ記事：丸型カート状態制御
// 2. ブログ記事／商品ページ：XO画像スライダー
// 3. ブログ記事／商品説明／固定ページ：本文画像クリック・タップ拡大
// 4. ブログ記事／商品説明：XOタブ切替
// 5. ブログ記事／商品説明：内容なしXOトグルを静的カード化
// 6. ブログ記事／商品説明：XOトグル開閉アニメーション
// 7. ブログ記事／商品説明：H2/H3プレビュー
// ============================================================


/* ============================================================
   1. FeaturedCollection／ブログ記事
      丸型カートボタン状態制御
   ============================================================ */

(function () {
  const BUTTON_SELECTOR =
    '.featured-collection .product-block__cart-button--compact[data-kugui-compact-cart], ' +
    '.kugui-article-product-grid .product-block__cart-button--compact[data-kugui-compact-cart]';

  const MIN_LOADING_TIME = 350;

  function setState(button, state) {
    if (!button) return;
    if (button.dataset.cartState === 'soldout' && state !== 'soldout') return;

    button.dataset.cartState = state;

    if (state === 'loading') button.setAttribute('aria-label', '追加中');
    else if (state === 'added') button.setAttribute('aria-label', '追加済み');
    else if (state === 'soldout') button.setAttribute('aria-label', '売り切れ');
    else button.setAttribute('aria-label', 'カートに追加');
  }

  function startLoading(button) {
    if (!button || button.disabled) return;
    if (button.dataset.cartState === 'soldout') return;
    if (button.dataset.cartState === 'loading') return;

    clearTimeout(button._kuguiAddedTimer);
    clearTimeout(button._kuguiCartFallback);

    button._kuguiLoadingStarted = Date.now();
    setState(button, 'loading');
  }

  function noticeIsActive(notice) {
    if (!notice) return false;
    if (notice.classList.contains('ajax-add-notice--pre-reveal')) return false;
    if (notice.classList.contains('ajax-add-notice--pre-replace')) return false;
    if (notice.style.display === 'none') return false;
    return true;
  }

  function processNotice(button, notice) {
    if (!notice || !noticeIsActive(notice)) return;

    /* 追加成功 */
    if (notice.classList.contains('ajax-add-notice--added')) {
      clearTimeout(button._kuguiCartFallback);
      clearTimeout(button._kuguiAddedTimer);

      const elapsed = Date.now() - (button._kuguiLoadingStarted || Date.now());
      const wait = Math.max(0, MIN_LOADING_TIME - elapsed);

      button._kuguiAddedTimer = setTimeout(function () {
        setState(button, 'added');
      }, wait);

      return;
    }

    /* 在庫・数量エラー */
    if (notice.classList.contains('ajax-add-notice--error')) {
      clearTimeout(button._kuguiCartFallback);
      clearTimeout(button._kuguiAddedTimer);
      setState(button, 'idle');
    }
  }

  function initButton(button) {
    if (!button || button.dataset.kuguiCartReady === 'true') return;

    if (button.dataset.cartState === 'soldout' || button.disabled) {
      button.dataset.kuguiCartReady = 'true';
      setState(button, 'soldout');
      return;
    }

    const form = button.closest('form');
    const card = button.closest('.product-block');

    if (!form || !card) return;

    button.dataset.kuguiCartReady = 'true';

    /* 押した瞬間にオレンジ＋白カートへ */
    button.addEventListener('pointerdown', function () {
      startLoading(button);
    }, true);

    /* キーボード・クリック操作への保険 */
    button.addEventListener('click', function () {
      startLoading(button);
    }, true);

    /* submit時もloadingを維持 */
    form.addEventListener('submit', function () {
      if (button.dataset.cartState !== 'loading') {
        startLoading(button);
      }

      clearTimeout(button._kuguiCartFallback);

      button._kuguiCartFallback = setTimeout(function () {
        if (button.dataset.cartState === 'loading') {
          setState(button, 'idle');
        }
      }, 10000);
    });

    /* テーマ標準AJAX通知を監視 */
    const noticeObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        const notices = [];

        if (
          mutation.target.nodeType === 1 &&
          mutation.target.matches &&
          mutation.target.matches('.ajax-add-notice')
        ) {
          notices.push(mutation.target);
        }

        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;

          if (node.matches && node.matches('.ajax-add-notice')) {
            notices.push(node);
          }

          if (node.querySelectorAll) {
            node.querySelectorAll('.ajax-add-notice').forEach(function (notice) {
              notices.push(notice);
            });
          }
        });

        notices.forEach(function (notice) {
          processNotice(button, notice);
        });
      });
    });

    noticeObserver.observe(card, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });
  }

  function initButtons(root) {
    if (!root) return;

    /* root自身が対象ボタンの場合 */
    if (root.nodeType === 1 && root.matches && root.matches(BUTTON_SELECTOR)) {
      initButton(root);
    }

    /* root内部の対象ボタン */
    if (root.querySelectorAll) {
      root.querySelectorAll(BUTTON_SELECTOR).forEach(initButton);
    }
  }

  function start() {
    initButtons(document);

    /*
     * ブログの商品一覧はfetch後に追加されるため、
     * DOMへ新しく追加された丸型カートを自動検出する。
     */
    const pageObserver = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          initButtons(node);
        });
      });
    });

    pageObserver.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  /* Shopifyテーマエディタでセクション再読込時 */
  document.addEventListener('shopify:section:load', function (event) {
    initButtons(event.target);
  });
})();


/* ============================================================
   2. ブログ記事／商品ページ
      XO画像スライダー
   ============================================================ */

(function () {
  function initKuguiSliders() {
    document.querySelectorAll('.xo-tunnel details.xot-toggle').forEach(function (toggle) {
      if (toggle.dataset.kuguiSliderReady === 'true') return;

      const summary = Array.from(toggle.children).find(function (el) {
        return el.tagName === 'SUMMARY';
      });

      if (!summary) return;

      const label = summary.textContent.replace(/\s+/g, '').trim();
      if (label !== '【画像スライダー】') return;

      const content = Array.from(toggle.children).find(function (el) {
        return el.classList.contains('xot-toggle__content');
      });

      if (!content) return;

      const figures = Array.from(
        content.querySelectorAll(':scope > figure.xot-img')
      ).filter(function (figure) {
        return figure.querySelector('img');
      });

      if (figures.length === 0) return;

      toggle.dataset.kuguiSliderReady = 'true';

      const slider = document.createElement('div');
      slider.className = 'kugui-image-slider';

      const stage = document.createElement('div');
      stage.className = 'kugui-image-slider__stage';

      const main = document.createElement('div');
      main.className = 'kugui-image-slider__main';

      const prev = document.createElement('button');
      prev.type = 'button';
      prev.className = 'kugui-image-slider__prev';
      prev.setAttribute('aria-label', '前の画像');
      prev.textContent = '‹';

      const next = document.createElement('button');
      next.type = 'button';
      next.className = 'kugui-image-slider__next';
      next.setAttribute('aria-label', '次の画像');
      next.textContent = '›';

      const thumbs = document.createElement('div');
      thumbs.className = 'kugui-image-slider__thumbs';

      let currentIndex = 0;

      function showImage(index) {
        if (index < 0) index = figures.length - 1;
        if (index >= figures.length) index = 0;

        currentIndex = index;
        main.replaceChildren(figures[index].cloneNode(true));

        thumbs.querySelectorAll('.kugui-image-slider__thumb').forEach(function (button, i) {
          const active = i === currentIndex;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }

      figures.forEach(function (figure, index) {
        const img = figure.querySelector('img');

        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'kugui-image-slider__thumb';
        button.setAttribute('aria-label', (index + 1) + '枚目の画像を表示');

        button.appendChild(img.cloneNode(true));

        button.addEventListener('click', function () {
          showImage(index);
        });

        thumbs.appendChild(button);
      });

      prev.addEventListener('click', function () {
        showImage(currentIndex - 1);
      });

      next.addEventListener('click', function () {
        showImage(currentIndex + 1);
      });

      stage.appendChild(main);

      if (figures.length > 1) {
        stage.appendChild(prev);
        stage.appendChild(next);
      }

      slider.appendChild(stage);
      slider.appendChild(thumbs);

      toggle.replaceWith(slider);
      showImage(0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initKuguiSliders);
  } else {
    initKuguiSliders();
  }

  document.addEventListener('shopify:section:load', initKuguiSliders);
})();


/* ============================================================
   3. ブログ記事／商品説明／固定ページ
      本文画像クリック・タップ拡大
   ============================================================ */

(() => {
  const IS_PAGE = window.location.pathname.startsWith('/pages/');

  if (IS_PAGE) {
    document.documentElement.classList.add('kugui-page-zoom');
  }

  function isZoomable(img) {
    if (!img || img.tagName !== 'IMG') return false;

    const inArticle =
      img.closest('[data-section-type="article"] > .rte');

    const inProduct =
      img.closest(
        '[data-section-type="product"] .product-page-description'
      );

    const inPage =
      IS_PAGE &&
      img.closest('main .rte');

    if (!inArticle && !inProduct && !inPage) return false;

    /* リンク画像・ボタン画像は本来の操作を優先 */
    if (img.closest('a')) return false;
    if (img.closest('button')) return false;

    /* 商品メイン画像はテーマ標準拡大を維持 */
    if (img.closest('.product-page-media-main')) return false;

    /* 明示的に拡大対象外としたもの */
    if (img.closest('[data-kugui-no-zoom]')) return false;

    return true;
  }

  function getLargestImageUrl(img) {
    const srcset = img.getAttribute('srcset');

    if (srcset) {
      const candidates = srcset
        .split(',')
        .map((item) => item.trim())
        .map((item) => {
          const parts = item.split(/\s+/);
          const url = parts[0];
          const descriptor = parts[1] || '';

          let size = 0;

          if (descriptor.endsWith('w')) {
            size = parseFloat(descriptor) || 0;
          } else if (descriptor.endsWith('x')) {
            size = (parseFloat(descriptor) || 0) * 10000;
          }

          return { url, size };
        })
        .sort((a, b) => b.size - a.size);

      if (candidates.length && candidates[0].url) {
        return candidates[0].url;
      }
    }

    return img.currentSrc || img.src;
  }

  function createLightbox() {
    let lightbox = document.querySelector('.kugui-image-lightbox');

    if (lightbox) return lightbox;

    lightbox = document.createElement('div');
    lightbox.className = 'kugui-image-lightbox';
    lightbox.hidden = true;

    const image = document.createElement('img');
    image.className = 'kugui-image-lightbox__image';
    image.alt = '';

    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'kugui-image-lightbox__close';
    close.setAttribute('aria-label', '拡大画像を閉じる');
    close.textContent = '×';

    lightbox.appendChild(image);
    lightbox.appendChild(close);
    document.body.appendChild(lightbox);

    function closeLightbox() {
      lightbox.hidden = true;
      image.removeAttribute('src');
      image.alt = '';
      document.documentElement.classList.remove(
        'kugui-lightbox-open'
      );
    }

    close.addEventListener('click', closeLightbox);

    lightbox.addEventListener('click', function (event) {
      if (event.target === lightbox) {
        closeLightbox();
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !lightbox.hidden) {
        closeLightbox();
      }
    });

    lightbox._kuguiClose = closeLightbox;

    return lightbox;
  }

  function openLightbox(img) {
    const lightbox = createLightbox();
    const image =
      lightbox.querySelector('.kugui-image-lightbox__image');

    image.src = getLargestImageUrl(img);
    image.alt = img.alt || '';

    lightbox.hidden = false;

    document.documentElement.classList.add(
      'kugui-lightbox-open'
    );
  }

  /*
   * イベント委譲にすることで、
   * XO画像スライダーで後から生成されたメイン画像にも対応。
   */
  document.addEventListener('click', function (event) {
    const img = event.target.closest
      ? event.target.closest('img')
      : null;

    if (!isZoomable(img)) return;

    event.preventDefault();
    openLightbox(img);
  });
})();
/* ============================================================
   4. ブログ記事／商品説明
      XOタブ切替
      260831 Shopify保存後のHTML構造に対応
   ============================================================ */

(() => {
  function initXotTabs(root = document) {
    const groups = [];

    if (
      root.nodeType === 1 &&
      root.matches &&
      root.matches('.xot-tabs')
    ) {
      groups.push(root);
    }

    if (root.querySelectorAll) {
      root.querySelectorAll('.xot-tabs').forEach((tabs) => {
        groups.push(tabs);
      });
    }

    groups.forEach((tabs) => {
      /* 同じDOMを二重初期化しない */
      if (tabs._xotTabsReady) return;

      const list = tabs.querySelector('.xot-tabs__list');

      const buttons = Array.from(
        tabs.querySelectorAll('.xot-tabs__tab[role="tab"]')
      );

      const panels = Array.from(
        tabs.querySelectorAll('.xot-tabs__panel[role="tabpanel"]')
      );

      if (!list || !buttons.length || !panels.length) return;

      tabs._xotTabsReady = true;

      /* Shopifyで削除されたARIA属性をJS側で復元 */
      list.setAttribute('aria-label', 'タブ');
      list.setAttribute('aria-orientation', 'horizontal');

      function getPanel(button, index) {
        /*
         * 基本：
         * xot-tab-XXXXX-1
         * ↓
         * xot-tab-XXXXX-1-panel
         */
        if (button.id) {
          const panel = tabs.querySelector(
            '#' + CSS.escape(button.id + '-panel')
          );

          if (panel) return panel;
        }

        /* ID対応が取れない場合のみ並び順で補完 */
        return panels[index] || null;
      }

      const relations = buttons.map((button, index) => ({
        button,
        panel:getPanel(button, index)
      }));

      function activateTab(activeButton, moveFocus = false) {
        relations.forEach(({ button, panel }) => {
          if (!panel) return;

          const active = button === activeButton;

          button.classList.toggle('is-active', active);
          button.setAttribute(
            'aria-selected',
            active ? 'true' : 'false'
          );
          button.tabIndex = active ? 0 : -1;

          button.setAttribute(
            'aria-controls',
            panel.id
          );

          panel.setAttribute(
            'aria-labelledby',
            button.id
          );

          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });

        if (moveFocus) {
          activeButton.focus();
        }
      }

      buttons.forEach((button, index) => {
        const panel = relations[index].panel;

        if (panel) {
          button.setAttribute('aria-controls', panel.id);

          if (button.id) {
            panel.setAttribute(
              'aria-labelledby',
              button.id
            );
          }
        }

        button.addEventListener('click', () => {
          activateTab(button);
        });

        button.addEventListener('keydown', (event) => {
          let targetIndex = null;

          if (event.key === 'ArrowRight') {
            targetIndex = (index + 1) % buttons.length;
          } else if (event.key === 'ArrowLeft') {
            targetIndex =
              (index - 1 + buttons.length) % buttons.length;
          } else if (event.key === 'Home') {
            targetIndex = 0;
          } else if (event.key === 'End') {
            targetIndex = buttons.length - 1;
          }

          if (targetIndex === null) return;

          event.preventDefault();
          activateTab(buttons[targetIndex], true);
        });
      });

      /* HTML上のis-activeを初期表示として採用。なければ1番目 */
      const initial =
        buttons.find((button) =>
          button.classList.contains('is-active')
        ) || buttons[0];

      activateTab(initial);
    });
  }

  function startXotTabs() {
    initXotTabs(document);

    /*
     * 外部アプリ等により後からHTMLが追加された場合にも対応。
     * DOM変化後に完成状態をまとめて再検索する。
     */
    let queued = false;

    const observer = new MutationObserver(() => {
      if (queued) return;

      queued = true;

      requestAnimationFrame(() => {
        queued = false;
        initXotTabs(document);
      });
    });

    observer.observe(document.body, {
      childList:true,
      subtree:true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      startXotTabs,
      { once:true }
    );
  } else {
    startXotTabs();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => initXotTabs(event.target)
  );
})();

/* ============================================================
   5. ブログ記事／商品説明
      XOトグル：内容なしを静的カード化
      260901
   ============================================================ */

(() => {
const TOGGLE_SELECTOR = [
  '[data-section-type="article"] .xo-tunnel details.xot-toggle',
  '[data-section-type="product"] .product-page-description .xo-tunnel details.xot-toggle'
].join(',');


  function hasMeaningfulContent(content) {
    if (!content) return false;

    /* 実際の文字があればコンテンツあり */
    const text = content.textContent.replace(/\u00a0/g, ' ').trim();
    if (text) return true;

    /* 文字がなくても、以下の要素があればコンテンツあり */
    return !!content.querySelector(
      'img,picture,figure,table,ul,ol,blockquote,hr,' +
      'details,video,audio,iframe,svg,canvas,' +
      'a[href],button,input,select,textarea'
    );
  }

  function updateEmptyToggles(root = document) {
    const toggles = [];

    if (root.nodeType === 1 && root.matches?.(TOGGLE_SELECTOR)) {
      toggles.push(root);
    }

    root.querySelectorAll?.(TOGGLE_SELECTOR).forEach((toggle) => {
      toggles.push(toggle);
    });

    toggles.forEach((toggle) => {
      const summary = toggle.querySelector(':scope > summary');
      const content = toggle.querySelector(':scope > .xot-toggle__content');

      if (!summary) return;

      const isEmpty = !hasMeaningfulContent(content);

      toggle.classList.toggle('is-empty', isEmpty);

      if (isEmpty) {
        toggle.removeAttribute('open');
        summary.setAttribute('aria-disabled', 'true');
        summary.setAttribute('tabindex', '-1');
      } else {
        summary.removeAttribute('aria-disabled');
        summary.removeAttribute('tabindex');
      }
    });
  }

  /* 内容なしトグルの標準開閉動作を停止
 * summary内のリンク操作のみ通常どおり許可
 */
document.addEventListener('click', (event) => {
  const summary = event.target.closest('.xot-toggle.is-empty > summary');
  if (!summary) return;

  /* summary内リンクは通常どおり動作させる */
  if (event.target.closest('a')) return;

  event.preventDefault();
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Enter' && event.key !== ' ') return;

  const summary = event.target.closest('.xot-toggle.is-empty > summary');
  if (!summary) return;

  /* summary内リンクはEnter等による通常操作を許可 */
  if (event.target.closest('a')) return;

  event.preventDefault();
});

  function startEmptyToggleCheck() {
    updateEmptyToggles(document);

    let queued = false;

    const observer = new MutationObserver(() => {
      if (queued) return;
      queued = true;

      requestAnimationFrame(() => {
        queued = false;
        updateEmptyToggles(document);
      });
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startEmptyToggleCheck, {
      once: true
    });
  } else {
    startEmptyToggleCheck();
  }

  document.addEventListener('shopify:section:load', (event) => {
    updateEmptyToggles(event.target);
  });
})();

/* XOテーブルの空タイトル行を判定。後から追加されるXO本文にも対応する。 */
(() => {
  const TABLE_SELECTOR =
    '[data-section-type="article"] .xot-table, ' +
    '[data-section-type="product"] .product-page-description .xot-table';

  function updateTable(table) {
    const firstRow = table.querySelector('tr');
    if (!firstRow) return;

    const cells = Array.from(firstRow.children);
    const isEmpty = cells.length > 0 &&
      cells.every((cell) => cell.tagName === 'TH' &&
        cell.textContent.replace(/\u00a0/g, ' ').trim() === '');

    firstRow.classList.toggle('xot-table__empty-head', isEmpty);
  }

  function initTables(root = document) {
    if (root.nodeType === 1 && root.matches?.(TABLE_SELECTOR)) {
      updateTable(root);
    }

    root.querySelectorAll?.(TABLE_SELECTOR).forEach(updateTable);
  }

  function start() {
    initTables(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        const table = mutation.target.closest?.(TABLE_SELECTOR);
        if (table) updateTable(table);

        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === 1) initTables(node);
        });
      });
    });

    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initTables(event.target);
  });
})();

/* ============================================================
   6. ブログ記事／商品説明
      XOトグル開閉アニメーション＋末尾クローズバー
      260914
   ============================================================ */

(() => {
const TOGGLE_SELECTOR = [
  '[data-section-type="article"] .xo-tunnel details.xot-toggle',
  '[data-section-type="product"] .product-page-description .xo-tunnel details.xot-toggle'
].join(',');

  const NORMAL_DURATION = 220;
  const REDUCED_DURATION = 0;
  const SCROLL_OFFSET = 50;

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  function getDuration() {
    return reduceMotion.matches
      ? REDUCED_DURATION
      : NORMAL_DURATION;
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function summaryIsFullyVisible(summary) {
    const rect = summary.getBoundingClientRect();

    return (
      rect.top >= 0 &&
      rect.bottom <= window.innerHeight
    );
  }

  function clearInlineState(content) {
    content.style.removeProperty('height');
    content.style.removeProperty('overflow');
    content.style.removeProperty('opacity');
    content.style.removeProperty('padding-top');
    content.style.removeProperty('padding-bottom');
    content.style.removeProperty('clip-path');
    content.style.removeProperty('transform');
    content.style.removeProperty('transform-origin');
    content.style.removeProperty('will-change');
  }

  function openToggle(toggle) {
    if (
      !toggle ||
      toggle.classList.contains('is-empty') ||
      toggle.classList.contains('is-animating') ||
      toggle.open
    ) {
      return;
    }

    const content =
      toggle.querySelector(':scope > .xot-toggle__content');

    if (!content) {
      toggle.open = true;
      return;
    }

    const duration = getDuration();

    toggle.classList.add('is-animating');
    toggle.open = true;

    const style = getComputedStyle(content);

    const fullHeight = content.scrollHeight;
    const paddingTop = parseFloat(style.paddingTop) || 0;
    const paddingBottom = parseFloat(style.paddingBottom) || 0;

    content.style.height = '0px';
    content.style.paddingTop = '0px';
    content.style.paddingBottom = '0px';
    content.style.opacity = '0.8';
    content.style.overflow = 'hidden';

    const startTime = performance.now();

    function step(now) {
      const progress = duration === 0
        ? 1
        : Math.min(1, (now - startTime) / duration);

      const eased = easeOutCubic(progress);

      content.style.height =
        (fullHeight * eased) + 'px';

      content.style.paddingTop =
        (paddingTop * eased) + 'px';

      content.style.paddingBottom =
        (paddingBottom * eased) + 'px';

      content.style.opacity =
        String(0.8 + (0.2 * eased));

      if (progress < 1) {
        requestAnimationFrame(step);
        return;
      }

      clearInlineState(content);
      toggle.classList.remove('is-animating');
    }

    requestAnimationFrame(step);
  }

  function closeToggleVisibleSummary(
    toggle,
    content
  ) {
    const duration = getDuration();

    const style = getComputedStyle(content);

    const startHeight =
      content.getBoundingClientRect().height;

    const paddingTop =
      parseFloat(style.paddingTop) || 0;

    const paddingBottom =
      parseFloat(style.paddingBottom) || 0;

    toggle.classList.add('is-animating');

    content.style.height =
      startHeight + 'px';

    content.style.overflow = 'hidden';

    const startTime = performance.now();

    function step(now) {
      const progress = duration === 0
        ? 1
        : Math.min(1, (now - startTime) / duration);

      const eased = easeOutCubic(progress);
      const remaining = 1 - eased;

      content.style.height =
        (startHeight * remaining) + 'px';

      content.style.paddingTop =
        (paddingTop * remaining) + 'px';

      content.style.paddingBottom =
        (paddingBottom * remaining) + 'px';

      content.style.opacity =
        String(0.8 + (0.2 * remaining));

      if (progress < 1) {
        requestAnimationFrame(step);
        return;
      }

      content.style.height = '0px';

      toggle.removeAttribute('open');

      requestAnimationFrame(() => {
        clearInlineState(content);
        toggle.classList.remove('is-animating');
      });
    }

    requestAnimationFrame(step);
  }

function closeToggleHiddenSummary(
  toggle,
  summary,
  content
) {
  const duration = getDuration();

  /*
   * このモードでは本文のレイアウト上の高さを維持し、
   * 見た目だけを巻き取る。
   */
  const startScrollY = window.scrollY;

  const summaryPageTop =
    summary.getBoundingClientRect().top +
    startScrollY;

  const targetScrollY = Math.max(
    0,
    summaryPageTop - SCROLL_OFFSET
  );

  toggle.classList.add('is-animating');

  content.style.willChange =
    'clip-path, transform, opacity';

  content.style.transformOrigin =
    'top center';

  const startTime = performance.now();

  function step(now) {
    const progress = duration === 0
      ? 1
      : Math.min(1, (now - startTime) / duration);

    const eased = easeOutCubic(progress);

    /*
     * 下側から本文を隠しながら、
     * ごく軽く上方向へ縮める。
     */
    const clipBottom =
      eased * 100;

    const scaleY =
      1 - (eased * 0.04);

    content.style.clipPath =
      `inset(0 0 ${clipBottom}% 0)`;

    content.style.transform =
      `scaleY(${scaleY})`;

    content.style.opacity =
      String(1 - (eased * 0.15));

    /*
     * 巻き取りと同じ進捗でsummaryへ移動。
     */
    const scrollY =
      startScrollY +
      ((targetScrollY - startScrollY) * eased);

    window.scrollTo(0, scrollY);

    if (progress < 1) {
      requestAnimationFrame(step);
      return;
    }

    /*
     * 260914 PC/SP：
     * 白い空白フレームを挟まず、その場で閉じ切る。
     */
    toggle.removeAttribute('open');
    clearInlineState(content);

    const finalSummaryTop =
      summary.getBoundingClientRect().top +
      window.scrollY;

    window.scrollTo(
      0,
      Math.max(
        0,
        finalSummaryTop - SCROLL_OFFSET
      )
    );

    toggle.classList.remove('is-animating');
  }

  requestAnimationFrame(step);
}

  function closeToggle(toggle) {
    if (
      !toggle ||
      toggle.classList.contains('is-empty') ||
      toggle.classList.contains('is-animating') ||
      !toggle.open
    ) {
      return;
    }

    const summary =
      toggle.querySelector(':scope > summary');

    const content =
      toggle.querySelector(':scope > .xot-toggle__content');

    if (!summary || !content) {
      toggle.removeAttribute('open');
      return;
    }

    if (summaryIsFullyVisible(summary)) {
      closeToggleVisibleSummary(
        toggle,
        content
      );
    } else {
      closeToggleHiddenSummary(
        toggle,
        summary,
        content
      );
    }
  }

  function addCloseBar(toggle) {
    if (
      !toggle ||
      toggle.classList.contains('is-empty')
    ) {
      return;
    }

    const content =
      toggle.querySelector(':scope > .xot-toggle__content');

    if (!content) return;

    if (
      content.querySelector(
        ':scope > .xot-toggle__closebar'
      )
    ) {
      return;
    }

    const button =
      document.createElement('button');

    button.type = 'button';
    button.className =
      'xot-toggle__closebar';

    button.setAttribute(
      'aria-label',
      'トグルを閉じる'
    );

    button.innerHTML =
      '<span class="xot-toggle__closebar-icon">▲</span>';

    button.addEventListener(
      'click',
      () => closeToggle(toggle)
    );

    content.appendChild(button);
  }

  function initToggle(toggle) {
    if (!toggle) return;

    addCloseBar(toggle);

    if (toggle._xotAnimatedToggleReady) {
      return;
    }

    const summary =
      toggle.querySelector(':scope > summary');

    if (!summary) return;

    toggle._xotAnimatedToggleReady = true;

    summary.addEventListener(
      'click',
      (event) => {
        /*
         * summary内リンクは通常操作を優先
         */
        if (event.target.closest('a')) {
          return;
        }

        /*
         * 空トグルは既存処理に任せる
         */
        if (
          toggle.classList.contains('is-empty')
        ) {
          return;
        }

        event.preventDefault();

        if (toggle.open) {
          closeToggle(toggle);
        } else {
          openToggle(toggle);
        }
      }
    );
  }

  function initToggles(root = document) {
    if (
      root.nodeType === 1 &&
      root.matches?.(TOGGLE_SELECTOR)
    ) {
      initToggle(root);
    }

    root.querySelectorAll?.(TOGGLE_SELECTOR)
      .forEach(initToggle);
  }

  function start() {
    initToggles(document);

    const observer =
      new MutationObserver(
        (mutations) => {
          mutations.forEach(
            (mutation) => {
              mutation.addedNodes.forEach(
                (node) => {
                  if (
                    node.nodeType !== 1
                  ) {
                    return;
                  }

                  initToggles(node);
                }
              );
            }
          );
        }
      );

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) =>
      initToggles(event.target)
  );
})();

/* ============================================================
   7. ブログ記事／商品説明
      H2/H3プレビュー型コンテンツ
      260925
   ============================================================ */

(() => {
  const PREVIEW_SELECTOR = [
    '[data-section-type="article"] .xo-tunnel section.xot-toggle--heading.xot-toggle--h2',
    '[data-section-type="article"] .xo-tunnel section.xot-toggle--heading.xot-toggle--h3',
    '[data-section-type="product"] .product-page-description .xo-tunnel section.xot-toggle--heading.xot-toggle--h2',
    '[data-section-type="product"] .product-page-description .xo-tunnel section.xot-toggle--heading.xot-toggle--h3'
  ].join(',');

  const NORMAL_DURATION = 240;
  const SCROLL_OFFSET = 50;

  const reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  );

  const readyToggles = new Set();

  let contentId = 0;
  let resizeQueued = false;


  /* ----------------------------------------------------------
     CSS変数取得
     ---------------------------------------------------------- */

  function getCssNumber(element, name, fallback) {
    const value = parseFloat(
      getComputedStyle(element).getPropertyValue(name)
    );

    return Number.isFinite(value)
      ? value
      : fallback;
  }


  /* ----------------------------------------------------------
     プレビュー先頭要素判定

     <p><br></p> のような空スペーサーは飛ばす。
     ---------------------------------------------------------- */

  function isMeaningfulElement(element) {
    if (
      element.matches(
        '.xot-toggle__preview-control,' +
        '.xot-toggle__closebar'
      )
    ) {
      return false;
    }

    const text = element.textContent
      .replace(/\u00a0/g, ' ')
      .trim();

    const hasVisualContent = !!element.querySelector(
      'img,picture,video,iframe,svg,canvas,' +
      'table,ul,ol,blockquote'
    );

    if (
      element.tagName === 'P' &&
      !text &&
      !hasVisualContent
    ) {
      return false;
    }

    return true;
  }


  function getFirstMeaningfulElement(content) {
    return Array.from(content.children)
      .find(isMeaningfulElement) || null;
  }


  /* ----------------------------------------------------------
     プレビュー高さ計算

     CSS変数 --kugui-preview-height の固定値を使用
     ---------------------------------------------------------- */

function calculatePreviewHeight(toggle) {
  return getCssNumber(
    toggle,
    '--kugui-preview-height',
    360
  );
}


  /* ----------------------------------------------------------
     高さアニメーション
     ---------------------------------------------------------- */

  function animateHeight(
    content,
    from,
    to,
    onProgress,
    onComplete
  ) {
    const duration =
      reduceMotion.matches
        ? 0
        : NORMAL_DURATION;

    if (duration === 0) {
      content.style.height = `${to}px`;

      if (onProgress) {
        onProgress(1);
      }

      onComplete();
      return;
    }

    const startTime =
      performance.now();

    function step(now) {
      const progress = Math.min(
        1,
        (now - startTime) / duration
      );

      const eased =
        1 - Math.pow(1 - progress, 3);

      const height =
        from +
        ((to - from) * eased);

      content.style.height =
        `${height}px`;

      if (onProgress) {
        onProgress(eased);
      }

      if (progress < 1) {
        requestAnimationFrame(step);
        return;
      }

      onComplete();
    }

    requestAnimationFrame(step);
  }


  /* ----------------------------------------------------------
     高さ再計算
     ---------------------------------------------------------- */

  function updatePreviewHeight(toggle) {
    const content =
      toggle.querySelector(
        ':scope > .xot-toggle__content'
      );

    if (!content) return;

    const previewHeight =
      calculatePreviewHeight(toggle);

    if (!previewHeight) return;

    content.dataset.kuguiPreviewHeight =
      String(previewHeight);

    /*
     * 展開中は現在の表示を維持。
     * 次回閉じるときだけ新しい高さを使う。
     */
    if (
      toggle.classList.contains(
        'is-preview-expanded'
      )
    ) {
      return;
    }

    const fullHeight =
      content.scrollHeight;

    /*
     * 本文全体がプレビュー高さより短い場合は
     * 折りたたみUI自体を出さない。
     */
    if (fullHeight <= previewHeight + 8) {
      toggle.classList.add(
        'is-preview-complete'
      );

      toggle.classList.remove(
        'is-preview-collapsed',
        'is-preview-expanded'
      );

      content.style.removeProperty(
        'height'
      );

      content.style.removeProperty(
        'overflow'
      );

      return;
    }

    toggle.classList.remove(
      'is-preview-complete'
    );

    toggle.classList.add(
      'is-preview-collapsed'
    );

    toggle.classList.remove(
      'is-preview-expanded'
    );

    content.style.height =
      `${previewHeight}px`;

    content.style.overflow =
      'hidden';
  }


  /* ----------------------------------------------------------
     全文展開
     ---------------------------------------------------------- */

  function expandPreview(toggle) {
    if (
      toggle.classList.contains(
        'is-preview-animating'
      ) ||
      toggle.classList.contains(
        'is-preview-complete'
      )
    ) {
      return;
    }

    const content =
      toggle.querySelector(
        ':scope > .xot-toggle__content'
      );

    const button =
      content?.querySelector(
        ':scope > .xot-toggle__preview-control ' +
        '.xot-toggle__preview-more'
      );

    if (!content) return;

    const startHeight =
      content.getBoundingClientRect().height;

    toggle.classList.add(
      'is-preview-animating'
    );

    toggle.classList.remove(
      'is-preview-collapsed'
    );

    toggle.classList.add(
      'is-preview-expanded'
    );

    if (button) {
      button.setAttribute(
        'aria-expanded',
        'true'
      );
    }

    /*
     * expanded状態にしたことで
     * closebarも含めた全文高さを取得できる。
     */
    const fullHeight =
      content.scrollHeight;

    content.style.height =
      `${startHeight}px`;

    content.style.overflow =
      'hidden';

    animateHeight(
      content,
      startHeight,
      fullHeight,
      null,
      () => {
        content.style.removeProperty(
          'height'
        );

        content.style.removeProperty(
          'overflow'
        );

        toggle.classList.remove(
          'is-preview-animating'
        );
      }
    );
  }


  /* ----------------------------------------------------------
     プレビュー状態へ戻す
     ---------------------------------------------------------- */

  function collapsePreview(toggle) {
    if (
      toggle.classList.contains(
        'is-preview-animating'
      ) ||
      !toggle.classList.contains(
        'is-preview-expanded'
      )
    ) {
      return;
    }

    const heading =
      toggle.querySelector(
        ':scope > .xot-toggle__heading'
      );

    const content =
      toggle.querySelector(
        ':scope > .xot-toggle__content'
      );

    const button =
      content?.querySelector(
        ':scope > .xot-toggle__preview-control ' +
        '.xot-toggle__preview-more'
      );

    if (!heading || !content) return;

    const previewHeight =
      parseFloat(
        content.dataset.kuguiPreviewHeight
      );

    if (!Number.isFinite(previewHeight)) {
      updatePreviewHeight(toggle);
      return;
    }

    const startHeight =
      content.getBoundingClientRect().height;

    const headingRect =
      heading.getBoundingClientRect();

    const headingIsVisible =
      headingRect.top >= 0 &&
      headingRect.bottom <=
        window.innerHeight;

    const startScrollY =
      window.scrollY;

    const headingPageTop =
      headingRect.top +
      startScrollY;

    const targetScrollY =
      Math.max(
        0,
        headingPageTop -
        SCROLL_OFFSET
      );

    toggle.classList.add(
      'is-preview-animating'
    );

    toggle.classList.remove(
      'is-preview-expanded'
    );

    toggle.classList.add(
      'is-preview-collapsed'
    );

    if (button) {
      button.setAttribute(
        'aria-expanded',
        'false'
      );
    }

    content.style.height =
      `${startHeight}px`;

    content.style.overflow =
      'hidden';

    animateHeight(
      content,
      startHeight,
      previewHeight,

      headingIsVisible
        ? null
        : (progress) => {
            const scrollY =
              startScrollY +
              (
                (
                  targetScrollY -
                  startScrollY
                ) *
                progress
              );

            window.scrollTo(
              0,
              scrollY
            );
          },

      () => {
        content.style.height =
          `${previewHeight}px`;

        content.style.overflow =
          'hidden';

        /*
         * 最終位置を再補正。
         */
        if (!headingIsVisible) {
          const finalPageTop =
            heading.getBoundingClientRect().top +
            window.scrollY;

          window.scrollTo(
            0,
            Math.max(
              0,
              finalPageTop -
              SCROLL_OFFSET
            )
          );
        }

        toggle.classList.remove(
          'is-preview-animating'
        );
      }
    );
  }


  /* ----------------------------------------------------------
     「続きを表示」UI
     ---------------------------------------------------------- */

  function addPreviewControl(
    toggle,
    content
  ) {
    let control =
      content.querySelector(
        ':scope > .xot-toggle__preview-control'
      );

    if (control) {
      return control;
    }

    control =
      document.createElement('div');

    control.className =
      'xot-toggle__preview-control';

    const button =
      document.createElement('button');

    button.type = 'button';

    button.className =
      'xot-toggle__preview-more';

const heading =
  toggle.querySelector(
    ':scope > .xot-toggle__heading'
  );

const headingText =
  heading?.textContent
    ?.replace(/\s+/g, ' ')
    .trim() || '';

const label =
  document.createElement('span');

label.className =
  'xot-toggle__preview-more-label';

label.textContent =
  '続きを表示 ▼';

button.appendChild(label);

if (headingText) {
  const title =
    document.createElement('span');

  title.className =
    'xot-toggle__preview-more-title';

  title.textContent =
    headingText;

  button.appendChild(title);

  button.setAttribute(
    'aria-label',
    `${headingText}の続きを表示`
  );
}

    button.setAttribute(
      'aria-expanded',
      'false'
    );

    button.addEventListener(
      'click',
      () => expandPreview(toggle)
    );

    control.appendChild(button);
    content.appendChild(control);

    return control;
  }


  /* ----------------------------------------------------------
     末尾closebar
     ---------------------------------------------------------- */

  function addPreviewClosebar(
    toggle,
    content
  ) {
    let button =
      content.querySelector(
        ':scope > .xot-toggle__closebar'
      );

    /*
     * 旧JS等ですでに存在する場合も再利用。
     */
    if (!button) {
      button =
        document.createElement('button');

      button.type = 'button';

      button.className =
        'xot-toggle__closebar';

button.innerHTML =
  '<span class="xot-toggle__closebar-icon">閉じる ▲</span>';

      content.appendChild(button);
    }

    button.setAttribute(
      'aria-label',
      'プレビュー表示に戻す'
    );

    if (
      button.dataset.kuguiPreviewBound ===
      'true'
    ) {
      return;
    }

    button.dataset.kuguiPreviewBound =
      'true';

    button.addEventListener(
      'click',
      () => collapsePreview(toggle)
    );
  }


  /* ----------------------------------------------------------
     初期化
     ---------------------------------------------------------- */

  function initPreviewToggle(toggle) {
    if (
      !toggle ||
      toggle.dataset.kuguiPreviewReady ===
        'true'
    ) {
      return;
    }

    const heading =
      toggle.querySelector(
        ':scope > .xot-toggle__heading'
      );

    const content =
      toggle.querySelector(
        ':scope > .xot-toggle__content'
      );

    if (!heading || !content) return;


    
    toggle.dataset.kuguiPreviewReady =
      'true';

    toggle.classList.add(
      'is-preview-ready',
      'is-preview-collapsed'
    );

    /*
     * ARIA関連
     */
    if (!content.id) {
      contentId += 1;

      content.id =
        `kugui-preview-content-${contentId}`;
    }

    const control =
      addPreviewControl(
        toggle,
        content
      );

    const moreButton =
      control.querySelector(
        '.xot-toggle__preview-more'
      );

    if (moreButton) {
      moreButton.setAttribute(
        'aria-controls',
        content.id
      );
    }

    addPreviewClosebar(
      toggle,
      content
    );

    readyToggles.add(toggle);

    /*
     * 画像読み込み後に再計算。
     */
    content.querySelectorAll('img')
      .forEach((img) => {
        if (img.complete) return;

        img.addEventListener(
          'load',
          () =>
            updatePreviewHeight(toggle),
          { once: true }
        );
      });

    /*
     * 先頭画像などのサイズ変化を監視。
     */
    const first =
      getFirstMeaningfulElement(content);

    if (
      first &&
      'ResizeObserver' in window
    ) {
      const observer =
        new ResizeObserver(() => {
          if (
            toggle.classList.contains(
              'is-preview-animating'
            )
          ) {
            return;
          }

          updatePreviewHeight(toggle);
        });

      observer.observe(first);

      toggle._kuguiPreviewResizeObserver =
        observer;
    }

    requestAnimationFrame(() => {
      updatePreviewHeight(toggle);
    });
  }


  function initPreviewToggles(
    root = document
  ) {
    if (
      root.nodeType === 1 &&
      root.matches?.(PREVIEW_SELECTOR)
    ) {
      initPreviewToggle(root);
    }

    root.querySelectorAll?.(
      PREVIEW_SELECTOR
    ).forEach(initPreviewToggle);
  }


  /* ----------------------------------------------------------
     PC/SP切替・画面幅変更時
     ---------------------------------------------------------- */

  function scheduleResizeUpdate() {
    if (resizeQueued) return;

    resizeQueued = true;

    requestAnimationFrame(() => {
      resizeQueued = false;

      readyToggles.forEach(
        (toggle) => {
          if (!toggle.isConnected) {
            readyToggles.delete(toggle);
            return;
          }

          if (
            !toggle.classList.contains(
              'is-preview-animating'
            )
          ) {
            updatePreviewHeight(toggle);
          }
        }
      );
    });
  }


  function startPreviewToggles() {
    initPreviewToggles(document);

    const observer =
      new MutationObserver(
        (mutations) => {
          mutations.forEach(
            (mutation) => {
              mutation.addedNodes.forEach(
                (node) => {
                  if (
                    node.nodeType !== 1
                  ) {
                    return;
                  }

                  initPreviewToggles(node);
                }
              );
            }
          );
        }
      );

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );

    window.addEventListener(
      'resize',
      scheduleResizeUpdate,
      { passive: true }
    );
  }


  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      startPreviewToggles,
      { once: true }
    );
  } else {
    startPreviewToggles();
  }

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initPreviewToggles(
        event.target
      );
    }
  );
})();

/* ============================================================
   11. ブログ記事／商品説明
       Xポスト公式カード表示
       261102
   ============================================================ */

(() => {
  const X_POST_SELECTOR = [
    '[data-section-type="article"] .xo-tunnel figure.xot-x-post',
    '[data-section-type="product"] .product-page-description .xo-tunnel figure.xot-x-post'
  ].join(',');

  const X_SCRIPT_SELECTOR = [
    'script[src*="platform.x.com/widgets.js"]',
    'script[src*="platform.twitter.com/widgets.js"]'
  ].join(',');

  const X_SCRIPT_URL =
    'https://platform.x.com/widgets.js';

  let scriptRequested = false;


  /* ----------------------------------------------------------
     対象Xポスト取得
     ---------------------------------------------------------- */

  function getXPosts(root = document) {
    const posts = [];

    if (
      root.nodeType === 1 &&
      root.matches?.(X_POST_SELECTOR) &&
      root.querySelector('.twitter-tweet')
    ) {
      posts.push(root);
    }

    root.querySelectorAll?.(
      X_POST_SELECTOR
    ).forEach((figure) => {
      if (
        figure.querySelector('.twitter-tweet')
      ) {
        posts.push(figure);
      }
    });

    return posts;
  }


  /* ----------------------------------------------------------
     H2/H3プレビュー内の高さ変化を監視
     ---------------------------------------------------------- */

  function watchPreviewResize(figure) {
    if (
      !figure.closest(
        'section.xot-toggle--heading'
      ) ||
      !('ResizeObserver' in window) ||
      figure._kuguiXResizeObserver
    ) {
      return;
    }

    let previousHeight =
      figure.getBoundingClientRect().height;

    let settleTimer = null;

    const observer =
      new ResizeObserver(() => {
        const currentHeight =
          figure.getBoundingClientRect().height;

        if (
          Math.abs(
            currentHeight -
            previousHeight
          ) < 1
        ) {
          return;
        }

        previousHeight =
          currentHeight;

        /*
         * Xカード生成後に既存の
         * H2/H3プレビュー高さを再計算させる。
         */
        window.dispatchEvent(
          new Event('resize')
        );

        clearTimeout(settleTimer);

        settleTimer =
          setTimeout(() => {
            observer.disconnect();
            delete figure._kuguiXResizeObserver;
          }, 1200);
      });

    observer.observe(figure);

    figure._kuguiXResizeObserver =
      observer;

    /*
     * X側が応答しない場合も監視を残し続けない。
     */
    setTimeout(() => {
      if (
        figure._kuguiXResizeObserver ===
        observer
      ) {
        observer.disconnect();
        delete figure._kuguiXResizeObserver;
      }
    }, 10000);
  }


  /* ----------------------------------------------------------
     X公式Widget APIでカード化
     ---------------------------------------------------------- */

  function loadXPosts(twttr, root = document) {
    if (
      !twttr?.widgets ||
      typeof twttr.widgets.load !==
        'function'
    ) {
      return;
    }

    getXPosts(root).forEach((figure) => {
      if (
        figure.dataset.kuguiXPostReady ===
        'true'
      ) {
        return;
      }

      watchPreviewResize(figure);

      try {
        twttr.widgets.load(figure);

        figure.dataset.kuguiXPostReady =
          'true';
      } catch (error) {
        /*
         * X側エラーでも既存リンクを残し、
         * 他のkugui-custom.js処理へ影響させない。
         */
      }
    });
  }


  /* ----------------------------------------------------------
     既存twttr APIを利用
     ---------------------------------------------------------- */

  function useExistingXApi(root = document) {
    if (
      window.twttr?.widgets &&
      typeof window.twttr.widgets.load ===
        'function'
    ) {
      loadXPosts(
        window.twttr,
        root
      );

      return true;
    }

    /*
     * widgets.js読込途中の
     * twttr.readyにも対応。
     */
    if (
      typeof window.twttr?.ready ===
        'function'
    ) {
      window.twttr.ready((twttr) => {
        loadXPosts(
          twttr,
          root
        );
      });

      return true;
    }

    return false;
  }


  /* ----------------------------------------------------------
     widgets.js 読込
     ---------------------------------------------------------- */

  function initXPosts(root = document) {
    /*
     * Xポストがなければ何もしない。
     */
    if (!getXPosts(root).length) {
      return;
    }

    /*
     * すでにX APIが利用可能なら
     * scriptを追加せずそのまま使用。
     */
    if (useExistingXApi(root)) {
      return;
    }

    /*
     * 既存widgets.jsがある場合は再利用。
     * 旧platform.twitter.comも二重読込防止対象。
     */
    const existingScript =
      document.querySelector(
        X_SCRIPT_SELECTOR
      );

    if (existingScript) {
      if (
        existingScript.dataset
          .kuguiXLoadBound !== 'true'
      ) {
        existingScript.dataset
          .kuguiXLoadBound = 'true';

        existingScript.addEventListener(
          'load',
          () => {
            useExistingXApi(document);
          },
          { once: true }
        );
      }

      return;
    }

    /*
     * 同一初期化中の二重追加防止。
     */
    if (scriptRequested) {
      return;
    }

    scriptRequested = true;

    const script =
      document.createElement('script');

    script.src =
      X_SCRIPT_URL;

    script.async = true;
    script.charset = 'utf-8';

    script.dataset.kuguiXWidgets =
      'true';

    script.addEventListener(
      'load',
      () => {
        useExistingXApi(document);
      },
      { once: true }
    );

    script.addEventListener(
      'error',
      () => {
        /*
         * 失敗時は何も置換しない。
         * blockquote内のリンクを
         * フォールバックとして残す。
         */
      },
      { once: true }
    );

    document.head.appendChild(script);
  }


  /* ----------------------------------------------------------
     初期ロード
     ---------------------------------------------------------- */

  if (
    document.readyState === 'loading'
  ) {
    document.addEventListener(
      'DOMContentLoaded',
      () => initXPosts(document),
      { once: true }
    );
  } else {
    initXPosts(document);
  }


  /* ----------------------------------------------------------
     Shopifyテーマエディタ再描画
     ---------------------------------------------------------- */

  document.addEventListener(
    'shopify:section:load',
    (event) => {
      initXPosts(
        event.target
      );
    }
  );
})();